<div class="home-page">

  <!-- Hero Header avec dégradé sportif -->
  <div class="hero-header">
    <p class="hero-header__greeting">
      Bonjour <strong>{{ getFirstname() || getUsername() }}</strong>
    </p>
    <p class="hero-header__subtitle">
      <mat-icon class="hero-header__icon">sports_soccer</mat-icon>
      Bienvenue sur ton espace MySociochaux
    </p>
  </div>

  <!-- Campagnes actives avec scroll horizontal -->
  <section class="home-section" *ngIf="campaigns.length > 0">
    <h2 class="section-title">
      <mat-icon>campaign</mat-icon> Campagnes en cours
    </h2>
    <div class="campaigns-scroll">
      <a class="campaign-card"
         *ngFor="let campaign of campaigns"
         [routerLink]="['/c', campaign.slug]">
        <mat-icon>campaign</mat-icon>
        <span>{{ campaign.name }}</span>
      </a>
    </div>
  </section>

  <!-- Mon Espace — grille d'actions avec cartes différenciées -->
  <section class="home-section">
    <h2 class="section-title">
      <mat-icon>sports_soccer</mat-icon> Mon espace
    </h2>
    <div class="action-grid">
      <a class="action-card" [routerLink]="['/wall-message']">
        <div class="action-card__icon action-card__icon--accent">
          <mat-icon>edit_note</mat-icon>
        </div>
        <span class="action-card__label">Ma plaque sur le mur</span>
      </a>
      <a class="action-card" href="https://mur.sociochaux.fr/" target="_blank" rel="noopener">
        <div class="action-card__icon action-card__icon--accent">
          <mat-icon>open_in_new</mat-icon>
        </div>
        <span class="action-card__label">Localiser ma brique sur le mur</span>
      </a>
      <a class="action-card" [routerLink]="['/account']">
        <div class="action-card__icon action-card__icon--blue">
          <mat-icon [matBadge]="notificationsService.notifications.compteIssues+notificationsService.notifications.socioIssues"
                    matBadgeColor="warn"
                    [matBadgeHidden]="!(notificationsService.notifications.compteIssues+notificationsService.notifications.socioIssues)">account_circle</mat-icon>
        </div>
        <span class="action-card__label">Mon profil</span>
      </a>
      <a class="action-card" [routerLink]="['/pronos']">
        <div class="action-card__icon action-card__icon--teal">
          <mat-icon [matBadge]="notificationsService.notifications.missingPronostics"
                    matBadgeColor="warn"
                    [matBadgeHidden]="!notificationsService.notifications.missingPronostics">check_box</mat-icon>
        </div>
        <span class="action-card__label">Mes Pronostics</span>
      </a>
      <a class="action-card" [routerLink]="['/consultations']">
        <div class="action-card__icon action-card__icon--indigo">
          <mat-icon [matBadge]="notificationsService.notifications.consultationsAvailable"
                    matBadgeColor="warn"
                    [matBadgeHidden]="!notificationsService.notifications.consultationsAvailable">how_to_vote</mat-icon>
        </div>
        <span class="action-card__label">Consultations / votes</span>
      </a>
      <a class="action-card" [routerLink]="['/suggestions']">
        <div class="action-card__icon action-card__icon--orange">
          <mat-icon [matBadge]="notificationsService.notifications.suggestionIssues"
                    matBadgeColor="warn"
                    [matBadgeHidden]="!notificationsService.notifications.suggestionIssues">lightbulb</mat-icon>
        </div>
        <span class="action-card__label">Suggestions</span>
      </a>
      <a class="action-card" [routerLink]="['/documents']">
        <div class="action-card__icon action-card__icon--green">
          <mat-icon [matBadge]="notificationsService.notifications.unreadDocs"
                    matBadgeColor="warn"
                    [matBadgeHidden]="!notificationsService.notifications.unreadDocs">folder_open</mat-icon>
        </div>
        <span class="action-card__label">Mes Documents</span>
      </a>
    </div>
  </section>

  <!-- Jeux -->
  <section class="home-section">
    <h2 class="section-title">
      <mat-icon>sports_esports</mat-icon> Jeux
    </h2>
    <a class="action-card action-card--wide" [routerLink]="['/games']">
      <div class="action-card__icon action-card__icon--gold">
        <mat-icon>sports_esports</mat-icon>
      </div>
      <span class="action-card__label">Accéder à la salle d'arcades</span>
    </a>
  </section>

  <!-- Déconnexion & Préférences — liens compacts -->
  <div class="home-quick-links">
    <button class="quick-link" (click)="openPreferences()">
      <mat-icon>tune</mat-icon> Préférences
    </button>
    <span class="quick-link-separator">·</span>
    <button class="quick-link quick-link--warn" (click)="disconnect()" [disabled]="isDisconnecting">
      <mat-icon>logout</mat-icon> {{ isDisconnecting ? 'Déconnexion...' : 'Déconnexion' }}
    </button>
  </div>

  <!-- Footer discret -->
  <div class="home-footer">
    <p class="home-version">MySocio v{{ version }}</p>
  </div>

</div>
